// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"style__pageTitle___Jawox","group":"style__group___twLmB","title":"style__title___thqxn"};


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Menu/style.scss
// module id = 1312
// module chunks = 0